import { EventEmitter } from '@angular/core';
import { StorageService, StorageType } from 'gast-common-ng';
import { StorageKeys } from '../constants/storage-keys';
var ShoppingCartService = /** @class */ (function () {
    function ShoppingCartService(storageService) {
        this.storageService = storageService;
        this.courseFound = new EventEmitter();
    }
    ShoppingCartService.prototype.getShoppingCartModel = function () {
        return this.storageService.getItem(StorageKeys.SHOPPING_CART_MODEL, StorageType.Session);
    };
    return ShoppingCartService;
}());
export { ShoppingCartService };
